<template>
    <div class="loading module-loading">
        <div class="spinner">
            <div class="spinner-inner">
            </div>
            <div class="cutout"></div>
            <div class="s-circle"></div>
        </div>
        <div class="loading-logo"><span class="icon-loading"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading'
}
</script>

<style lang="scss">
    .module-loading {
        position: relative;
        width: 100%;
        height: 79px;
        z-index: 22;
        background: transparent;
        .spinner {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 68px;
            height: 68px;
            text-align: center;
            margin-left: -34px;
            margin-top: -34px;
            background: -webkit-gradient(radial, 100% 50%, 0, 100% -38%, 100, from(#1dbd8d), to(#fff));
            border-radius: 100%;
            -webkit-animation: rotate 2s linear 0s infinite;
            -moz-animation: rotate 2s linear 0s infinite;
            animation: rotate 2s linear 0s infinite;
            .spinner-inner {
                position: relative;
                top: 3px;
                left: 3px;
                width: 62px;
                height: 62px;
                background: #fff;
                border-radius: 100%;
            }
            .cutout {
                position: absolute;
                top: 34px;
                left: 35px;
                border-right: 34px solid #fff;
                border-bottom: 34px solid #fff;
                -webkit-border-top-left-radius: 0px;
                -webkit-border-top-right-radius: 0px;
                -webkit-border-bottom-right-radius: 34px;
                -webkit-border-bottom-left-radius: 0px;
                width: 0em;
                height: 0em;
                padding: 0;
            }
            .s-circle {
                width: 3px;
                height: 3px;
                background: #1DBD8D;
                position: absolute;
                top: 33px;
                right: 0;
                border-radius: 3px;
            }
        }
        .loading-logo {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -20px;
            margin-top: -20px;
            color: #1DBD8D;
            font-size: 40px;
            opacity: 0.8;
        }
    }
    @keyframes rotate {
        0% {
            -webkit-transform:rotate(0)
        }
        100% {
            -webkit-transform:rotate(360deg)
        }
    }
    @-webkit-keyframes rotate {
        0% {
            -webkit-transform:rotate(0)
        }
        100% {
            -webkit-transform:rotate(360deg)
        }
    }
</style>



// WEBPACK FOOTER //
// Loading.vue